/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTextValueListDto
 */
export interface CreateTextValueListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTextValueListDto
     */
    selectedValues?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTextValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueListDto
     */
    $type?: CreateTextValueListDtoTypeEnum;
}


/**
 * @export
 */
export const CreateTextValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateTextValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateTextValueListDtoTypeEnum = typeof CreateTextValueListDtoTypeEnum[keyof typeof CreateTextValueListDtoTypeEnum];


/**
 * Check if a given object implements the CreateTextValueListDto interface.
 */
export function instanceOfCreateTextValueListDto(value?: unknown): value is CreateTextValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateTextValueListDtoTypeEnum)[0];
}

export function CreateTextValueListDtoFromJSON(json: any): CreateTextValueListDto {
    return CreateTextValueListDtoFromJSONTyped(json, false);
}

export function CreateTextValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTextValueListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'selectedValues': !exists(json, 'selectedValues') ? undefined : json['selectedValues'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateTextValueListDtoToJSON(value?: CreateTextValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'dataTypeId': value.dataTypeId,
        'selectedValues': value.selectedValues,
        'isEnabled': value.isEnabled,
        '$type': value.$type,
    });
}

